/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import type { Provider, TransactionRequest } from "@ethersproject/providers";
import type { PromiseOrValue } from "../../../../common";
import type {
  AccessControlStorage,
  AccessControlStorageInterface,
} from "../../../../contracts/dependant/accessControl/AccessControlStorage";

const _abi = [
  {
    inputs: [
      {
        internalType: "address",
        name: "owner_",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
] as const;

const _bytecode =
  "0x6080604052348015600f57600080fd5b5060405160c838038060c8833981016040819052602a91604e565b600080546001600160a01b0319166001600160a01b0392909216919091179055607c565b600060208284031215605f57600080fd5b81516001600160a01b0381168114607557600080fd5b9392505050565b603f8060896000396000f3fe6080604052600080fdfea264697066735822122083b527b26b4917218b3915550dda487c8a913bc895bbedb01752b16b61a28b2f64736f6c63430008110033";

type AccessControlStorageConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: AccessControlStorageConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class AccessControlStorage__factory extends ContractFactory {
  constructor(...args: AccessControlStorageConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  override deploy(
    owner_: PromiseOrValue<string>,
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): Promise<AccessControlStorage> {
    return super.deploy(
      owner_,
      overrides || {}
    ) as Promise<AccessControlStorage>;
  }
  override getDeployTransaction(
    owner_: PromiseOrValue<string>,
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(owner_, overrides || {});
  }
  override attach(address: string): AccessControlStorage {
    return super.attach(address) as AccessControlStorage;
  }
  override connect(signer: Signer): AccessControlStorage__factory {
    return super.connect(signer) as AccessControlStorage__factory;
  }

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): AccessControlStorageInterface {
    return new utils.Interface(_abi) as AccessControlStorageInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): AccessControlStorage {
    return new Contract(
      address,
      _abi,
      signerOrProvider
    ) as AccessControlStorage;
  }
}
